export default {
      id: "oc-icon_optimization-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "sprite.svg#oc-icon_optimization",
      toString: function () {
        return this.url;
      }
    }